import { IconButton } from '../../../../actions/iconButton/IconButton'
import { useTranslate } from '../../../../hooks/useTranslate'
import { Dropdown } from '../../../../structure/dropdown/Dropdown'
import type { ColumnFilterState } from '../../useFilterState'
import { FilterCheckbox } from './FilterCheckbox'

type State<T> = ColumnFilterState<T> & { type: 'auto' }

type Props<T> = {
  state: State<T>
  onStateChanged: (state: State<T>) => void
}

export const CheckFilter = <T,>({ state, onStateChanged }: Props<T>) => {
  const translate = useTranslate()

  return (
    <Dropdown
      element={
        <IconButton
          iconName="Filter"
          isSelected={!state.options.every((o) => o.checked)}
          className="-m-1"
        />
      }
      items={[
        {
          element: (
            <FilterCheckbox
              label={translate('table.filter.toggleAll')}
              checked={state.options.some(({ checked }) => checked)}
              indeterminate={state.options.some(({ checked }) => !checked)}
              onChange={() => {
                const checked = !state.options.every(({ checked }) => checked)
                onStateChanged({
                  ...state,
                  options: state.options.map((option) => ({
                    ...option,
                    checked,
                  })),
                })
              }}
            />
          ),
        },
        {
          isDivider: true,
        },
        ...state.options.map((option) => ({
          element: (
            <FilterCheckbox
              label={option.label}
              checked={option.checked}
              onChange={() =>
                onStateChanged({
                  ...state,
                  options: state.options.map((o) =>
                    o === option ? { ...o, checked: !o.checked } : o,
                  ),
                })
              }
            />
          ),
        })),
      ]}
    />
  )
}
